import React from 'react';
import Text from './base';

const H5 = props => <Text defaultTag="h5" variant="h5" {...props} />;

export default H5;
